import { render, staticRenderFns } from "./UserManagement2.vue?vue&type=template&id=c8d0cff6&scoped=true"
import script from "./UserManagement2.vue?vue&type=script&lang=js"
export * from "./UserManagement2.vue?vue&type=script&lang=js"
import style0 from "./UserManagement2.vue?vue&type=style&index=0&id=c8d0cff6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8d0cff6",
  null
  
)

export default component.exports